export default {

  // FrontPage.vue
  frontPageRequirementTitle: '我的',
  frontPageProvideTitle: '供應',
  frontPagePersonalCenterTitle: '我的',
  login: '登入',
  home_chatWithOctopie: '正在理解你的想法',
  home_chatNeedUnderstood: '已理解你的想法',
  home_draftBannerTitle: '繼續完善你的訊息',
  home_draftBannerSubtitle: 'AI 已幫你整理好，點這裡繼續',
  home_tabHome: '首頁',
  // App.vue
  appRequirementTitle: '您的每一條需求/吐槽我們都將認真傾聽',
  appRequirementBtn: '提交',
  appSubmitSuccess: '提交成功，感謝您的回饋',
  appFeedbackLink: '提需求/吐槽',
  mobile_banner_text: '為了獲得最佳體驗，請使用 App',
  mobile_banner_btn: '下載 App',

  // 通用
  loading: '載入中...',
  confirm: '確認',
  cancel: '取消',
  save: '儲存',
  delete: '刪除',
  edit: '編輯',
  add: '新增',
  search: '搜尋',
  refresh: '重新整理',
  change_batch: '換一批',
  back: '返回',
  submit: '提交',
  close: '關閉',
  ok: '確定',
  yes: '是',
  no: '否',
  send: '發送',
  block: '封鎖',
  more: '更多',
  logout: '登出',
  settings: '設定',
  view_guide: '查看引導',
  feedback: '意見回饋',
  feedback_title: '意見回饋',
  feedback_new: '新增回饋',
  feedback_empty: '暫無回饋',
  feedback_hint: '說說你的想法...',
  feedback_submit: '提交',
  feedback_submit_success: '回饋提交成功',
  feedback_submit_failed: '回饋提交失敗',
  feedback_reply_label: '平台回覆',
  register: '註冊',
  name: '暱稱',
  email: '電子郵件',
  mobile: '手機號碼',
  password: '密碼',
  verification_code: '驗證碼',
  company_name: '北京兩少科技有限公司',
  all_rights_reserved: '版權所有',
  footerVersion: '版本 {version}',
  copy: '複製',
  regenerate: '重新產生',
  generate: '產生',
  contact_now: '立即聯絡',
  yours: '你的',
  xiaoyao_analysis: 'AI 來分析',
  brand_name: 'OctoSay',
  anonymous: '匿名',
  no_summary: '暫無摘要',
  file: '檔案',
  discover: '發現',
  discover_title: '發現',
  discover_hotChannels: '熱門頻道',
  discover_allChannels: '全部',
  discover_searchChannel: '搜尋頻道',
  discover_noChannels: '暫無頻道',

  // 提示訊息
  operationSuccess: '操作成功',
  operationFailed: '操作失敗',
  networkError: '網路錯誤，請稍後重試',
  dataLoadingFailed: '資料載入失敗',
  noData: '暫無資料',
  deleteConfirm: '確定要刪除嗎？',
  saveConfirm: '確定要儲存嗎？',

  // 表單驗證
  required: '此項為必填項',
  emailInvalid: '請輸入有效的電子郵件地址',
  phoneInvalid: '請輸入有效的手機號碼',
  passwordTooShort: '密碼長度不能少於{min}位',
  passwordMismatch: '兩次輸入的密碼不一致',

  // 時間
  today: '今天',
  yesterday: '昨天',
  justNow: '剛剛',
  minutesAgo: '{min}分鐘前',
  hoursAgo: '{hour}小時前',
  daysAgo: '{day}天前',

  // Footer
  about: '關於',
  footerPrivacy: '隱私權政策',
  footerTerms: '服務條款',
  footerSupport: '幫助與支援',

  // Register
  registerAgeConfirm: '我已年滿13歲',
  registerAgeConfirm18: '我已年滿18週歲',
  registerTermsPrefix: '我已閱讀並同意',
  registerTermsAnd: '和',
  registerAgeError: '請確認你的年齡',
  registerTermsError: '請同意條款和隱私權政策',

  // Chat
  chatPrivacyTip: '在群組裡輸入你想說的話，AI 會先和你聊天確認細節。你確認後，你的訊息和配對摘要會一起發出去，AI 再持續幫你配對。',
  aiChat_quickSuggestions: '試試說',
  aiChat_welcome: "嗨，說說你想找什麼吧～",

  // Chat - AI Progress Steps (new)
  aiChat_readyToPost: '細節已理解，發布後 AI 幫你配對到對的人',
  aiChat_readyToPostHint: '發布後想補充細節，隨時繼續和 AI 聊',
  aiChat_progressStep1: '理解細節',
  aiChat_progressStep1Done: '細節已理解',
  aiChat_progressStep2: 'AI 來總結',
  aiChat_progressStep2Desc: 'AI 幫你提煉，方便群友配對',
  aiChat_progressStep3: '發布到群組',
  aiChat_progressStep3Desc: '發布後 AI 幫你配對到對的人',
  aiChat_publishExtraHint: '請輸入你想對群友說的話',
  aiChat_publishMsgRequired: '必填',
  aiChat_publishMsgLabel: '你要對群友說的話',
  aiChat_matchSummaryLabel: 'AI 來總結',

  ai_generated_label: 'AI 生成',

  ai_content_disclaimer: '以下內容由 AI 生成，僅供參考，請注意甄別',
  aiChat_publishSuggestionHint: '點擊替換',
  aiChat_allowDirectContact: '允許直接聯絡',
  aiChat_allowDirectContactDesc: '其他人無需配對即可直接聯絡你',
  channel_chat_session_publishToChannel: '發布到 Octo 群組',
  aiChat_newChat: '重設',

  // 群組 / 頻道
  home_tabChannels: 'Octo 群組',
  channels_title: 'Octo 群組',
  channels_myChannels: '已加入的群組',
  channels_discover: '發現',
  channels_noChannels: '暫無群組',
  channels_noMyGroupsTitle: '你還沒有加入任何群組',
  channels_noMyGroupsSubtitle: '去搜尋一個群組加入，開始認識新朋友吧',
  channels_searchGroupsBtn: '搜尋群組',
  channels_loginPrompt: '請登入後查看群組',
  channels_create: '建立 Octo 群組',
  channels_search: '搜尋 Octo 群組',
  channels_searchMyGroups: '搜尋我的 Octo 群組',
  channels_searchHint: '搜尋',
  channels_searchHintChats: '搜尋聊天...',
  channels_searchHintGroups: '搜尋群組...',
  channels_searchHintMy: '搜尋已加入的群組...',
  channels_joinByCode: '群組代碼加入',
  channels_joinByCodeTitle: '透過 Octo 群組 代碼加入',
  channels_joinByCodeHint: '輸入 Octo 群組 代碼',
  channels_joinByCodeConfirm: '加入',
  channels_joinByCodeNotFound: '未找到該群組',
  channels_createNewGroup: '建立新 Octo 群組',
  channels_noResults: '未找到相關群組',
  channel_detail_join: '加入群組',
  channel_detail_leave: '退出',
  channel_detail_members: '成員',
  // 聚合进群消息 banner（joinMsgs）
  channelJoinMsg_oneJoined: '{name} 加入了群組',
  channelJoinMsg_twoJoined: '{name1}、{name2} 加入了群組',
  channelJoinMsg_multiJoined: '{name1}、{name2} 和另外 {n} 人加入了群組',
  channelJoinMsg_oneAndMoreJoined: '{name} 和另外 {n} 人加入了群組',
  channelJoinMsg_membersJoined: '{n} 人加入了群組',

  // Feed
  channels_feed: '聊天',
  channels_groups: '群組',
  feed_related: '相關',
  feed_recommend: '推薦',
  feed_empty: '還沒有動態，先去熱門群組逛逛吧',
  feed_goToGroup: '進群組看看',
  feed_joinGroupAndSendMsg: '加入群組，發則訊息',
  channel_detail_channelCode: 'Octo 群組 代碼',
  channel_detail_invitePhrase: '邀你加入「{name}」\n群口令 {code}，打開App自動進群 · AI先幫你澄清，再搖到對的人',
  channel_detail_post: '發布到群組',
  channel_detail_aiHint: "在群組裡寫訊息，AI 會先確認細節",
  channel_input_hint: '說點什麼…',
  channel_leave_confirm_message: '確定要退出該群組嗎？退出後將不再收到群組訊息。',
  channel_invite_notFound: '群組不存在或連結已失效',
  channel_invite_joinBtn: '下載 OctoSay App',
  channel_invite_hint: '下載 App 後，掃描此 QR Code 或搜尋群組名稱即可加入',
  channel_invite_globalHintTitle: '您當前要下載的是國際版App',
  channel_invite_globalHintIOS: '中國區 App Store 無法直接下載，建議切換至非中國區 Apple Store 搜尋 OctoSay，或點擊下方直接下載',
  channel_invite_globalHintAndroid: '中國無法直接存取 Google Play，建議點擊下方直接下載 APK 安裝包，或嘗試前往 Google Play',
  channel_invite_globalHintDefault: '中國應用程式商店可能無法直接下載，建議點擊下方直接下載 APK 安裝包，或嘗試前往 App Store',
  channel_invite_globalBtnAppStore: '前往 App Store',
  channel_invite_globalBtnGooglePlay: '前往 Google Play',
  channel_invite_globalBtnAPK: '直接下載 APK',
  channel_invite_defaultDesc: '加入 {name} - OctoSay',
  share: '分享',
  share_channel: '分享群組',
  share_channel_link: '分享連結',
  channel_detail_inviteCode: '群組口令',
  channel_detail_copyLink: '複製連結',
  share_session_title: 'OctoSay 上的一則貼文',
  share_match_title: 'OctoSay 上的一次配對',
  share_session_text: '{userName}：{summary}',
  share_session_text_no_summary: '看看 {userName} 在 OctoSay 上發了什麼',
  session_share_notFound: '貼文不存在或連結已失效',
  session_share_fromChannel: '來自 Octo 群組',
  session_share_downloadBtn: '下載 OctoSay App',
  session_share_hint: '下載 App 後即可查看完整貼文並加入群組',
  session_share_openInApp: '在 App 中開啟',
  toast_link_copied: '連結已複製',
  toast_no_share_data: '沒有可分享的內容',
  channels_joinByQR: 'QR Code',
  channels_joinByQRWebHint: '網頁版暫不支援掃碼，請輸入 Octo 群組 代碼加入',
  channels_joinByQRTitle: '掃描 QR Code 加入',
  channel_detail_qrCode: 'QR Code',
  channel_detail_qrCodeSave: '儲存圖片',
  channel_detail_qrCodeSaveHint: '右鍵點擊圖片儲存',
  channel_detail_qrCodeSaved: '已儲存到相簿',
  channel_detail_qrCodeSaveFailed: '儲存失敗，請重試',
  channel_detail_locateFailed: '定位訊息失敗',
  channel_detail_locateError: '定位訊息出錯',
  channel_detail_myMessages: '我的訊息',
  channel_detail_searchMessages: '搜尋訊息',
  channel_detail_aiChat: 'AI 對話',
  channel_detail_matchHistory: '配對歷史',
  channel_create_title: '建立 Octo 群組',
  channel_create_name: 'Octo 群組 名稱',
  channel_create_description: 'Octo 群組 簡介',
  channel_create_submit: '建立',
  channelCreate_aiAssist: 'AI 將幫你建立一個合適的群組',
  channelCreate_nameHint: '輸入群組名稱',
  channelCreate_descHint: '描述你的群組是做什麼的',
  channelCreate_creating: '建立中...',
  channelCreate_created: '群組建立成功！',
  channelCreate_failed: '建立群組失敗',
  channelCreate_welcomeMsg: "你好！我是 AI，我來幫你建立群組。告訴我你想建什麼樣的群組——比如群組的名稱、主題或用途，我會幫你整理成群組介紹。",
  channelCreate_aiHint: '寫下你的群組主題...',
  channelCreate_clarifyingProgress: '正在整理你的群組主題...',
  channelCreate_readyToCreate: '可以建立 Octo 群組 了',
  channelCreate_step1: '說明主題',
  channelCreate_step1Done: '想法已明確',
  channelCreate_step2: '建立 Octo 群組',
  channelCreate_confirmBtn: '確認建立',
  channelCreate_publicNotice: '群組是公共交流空間，供有共同興趣的人在此聚集。群組不屬於建立者個人所有。平台有權對群組進行管理、調整或合併。歡迎將群組分享給可能感興趣的其他人。',
  channelCreate_similarGroupsTitle: '發現相似 Octo 群組',
  channelCreate_similarGroupsDesc: '這些群組可能適合你',
  channelCreate_exactMatchHint: '已存在同名群組！',
  channelCreate_joinHint: '這些已有群組可能適合你',
  channelCreate_joinExisting: '加入已有 Octo 群組',
  channelCreate_stillCreate: '仍要建立新 Octo 群組',
  channel_chat_session_comments: '留言',
  channel_chat_session_commentHint: '寫一則留言...',
  channel_chat_session_sendComment: '回覆',
  channel_chat_session_loadMore: '載入更多',
  channel_chat_session_noComments: '暫無留言',
  channel_chat_session_deleteComment: '刪除',
  channelSearch_title: '群組內搜尋',
  channelSearch_placeholder: '搜尋訊息...',
  channelSearch_onlyMine: '僅我的發布',
  channelSearch_tabAllMessages: '群組訊息',
  channelSearch_tabMyMessages: '我的訊息',
  chatMsgSearch_placeholder: '搜尋訊息',
  chatMsgSearch_tabMsgs: '訊息',
  chatMsgSearch_tabContacts: '聯絡人',
  chatMsgSearch_emptyPrompt: '輸入關鍵字搜尋訊息',
  chatMsgSearch_tooShort: '至少輸入 2 個字再搜尋',
  chatMsgSearch_contactEmptyPrompt: '輸入使用者名稱或電子郵件搜尋聯絡人',
  chatMsgSearch_noContacts: '未找到相關聯絡人',
  chatMsgSearch_inChatPlaceholder: '在目前聊天中搜尋',
  channelHistory_title: '歷史訊息',
  channelHistory_myMessages: '我發的訊息',
  channelHistory_loadMore: '載入更多',
  channel_settings_push: 'Octo 群組 訊息通知',
  channel_settings_commentPush: '留言通知',
  channel_settings_likePush: '按讚通知',
  channel_settings_receiveNotifications: '接收通知',
  channel_settings_directContact: '允許直接聯絡',
  session_published: '已發布',
  session_publishFailed: '發布失敗',
  session_setDirectContactSuccess: '設定已儲存',
  session_setDirectContactFailed: '儲存設定失敗',
  session_setPrivate: '設為私密',
  session_setPublic: '設為公開',
  session_pauseMatching: '暫停匹配',
  session_resumeMatching: '恢復匹配',
  session_matchPausedToast: '已暫停匹配',
  session_matchResumedToast: '已恢復匹配',
  match_matchingPausedTitle: '匹配已暫停',
  match_reasonTag: '匹配理由',
  match_matchingPausedHint: '隨時可恢復匹配',
  session_confirmSetPrivate: '確定將此內容設為私密？其他使用者將無法查看。',
  session_messageIsPrivate: '該訊息為私密訊息',
  chatSessionComment_replyHint: '寫一則留言...',
  chatSessionComment_reply: '留言',
  chatSessionComment_count: '{n}則留言',
  chatSessionMatch_count: '{n}個配對',
  chatSessionComment_replyTo: '回覆',
  chatSessionComment_inputHint: '寫留言...',
  chatSessionComment_send: '發送',
  chatSessionComment_delete: '刪除',
  chatSessionComment_deleteConfirm: '確定要刪除這則留言嗎？',
  chatSessionComment_loadMore: '載入更多',
  chatSessionComment_noMore: '沒有更多留言了',
  chatSessionComment_loginToComment: '請登入後留言',
  chatSessionComment_viewEarlier: '查看更早{n}則回覆',
  chatSessionLike_like: '按讚',
  chatSessionLike_liked: '已按讚',
  chatSessionLike_count: '個讚',
  chatSessionBookmark_bookmark: '收藏',
  chatSessionBookmark_bookmarked: '已收藏',
  chatSessionMatch_viewMatches: '查看配對',
  chatSessionMatch_matchHistory: '配對歷史',
  chatSessionMatch_noMatches: '暫無配對',
  channel_match_achievement: '已有 {count} 個內容成功配對',
  channel_match_achievement_view: '查看 →',
  channel_matchHistory_title: '頻道配對歷史',
  chatSessionMatch_matchedAt: '配對於 {time}',
  discover_userMsgLabel: '對方說',
  common_loading: '載入中...',
  common_sending: '發送中...',
  common_error: '錯誤',
  common_success: '成功',
  common_me: '我',

  // Chat - Set Public / Pick Location
  aiChat_clarifyingProgress: "AI 在澄清你的想法，確保發出去的每則訊息都有效；發布後會持續為你搖到對的人",
  aiChat_clarifyingAlmostDone: '即將完成，請確認一下',
  aiChat_clarifyingOneMore: '預計再回答 1 個問題即可，馬上就能發布',
  aiChat_clarifyingRemaining: '預計還需 {count} 輪對話，很快就好',
  aiChat_clarifyingEvaluating: '正在評估進度...',
  aiChat_setPublicMatch: '設為公開並配對',
  aiChat_needsClarifiedPublic: "我已經懂你了。你確認發布後，AI 會持續為你搖合適的人，有新結果會第一時間告訴你。\n也可以隨時告訴我更多細節。",
  aiChat_needsClarifiedPrivate: '已大概知曉你的想法！設為公開讓 AI 持續為你搖合適的人！',
  aiChat_setPublicTitle: '設為公開',
  aiChat_setPublicMessage: '你的內容將對其他人可見，以便 OctoSay 持續為你配對到合適的TA。\n\n將分享的資訊：\n• 你的使用者名稱和大頭貼\n• 你的內容摘要\n• 對話內容\n\n你可以隨時將其設回私密。',
  aiChat_findMatches: '查看配對結果',
  aiChat_publishing: '發布中...',
  aiChat_matchSectionTitle: '你的訊息最適合發布到這些群組，點群名直接發布',
  aiChat_joinedBadge: '已加入',
  aiChat_matchSectionEmpty: '暫時沒有匹配度高的群組，可以直接建立一個新群組發布',
  aiChat_suggestPublishCreateNew: '建立新群組',
  aiChat_repickChannel: '重新選群',
  aiChat_creatingChannelTitle: '沒找到合適的群組，正在為你建立',
  aiChat_creatingChannelHint: 'AI 正在按你的需求起名建群，完成後直接進入發布，通常需要 10~30 秒',
  aiChat_publishToChannelHint: '將發布到「{name}」',
  aiChat_pickChannelTitle: '選擇發布的群組',
  aiChat_matchingChannelTitle: '正在為你配對合適的群組',
  aiChat_matchingChannelHint: 'AI 正在根據你的需求搜尋，通常需要幾秒到半分鐘，請稍候',
  aiChat_matchUnavailableTitle: '推薦暫時不可用',
  aiChat_matchUnavailableHint: '可以直接搜尋下面的群組，或關閉後重新打開發布再試',
  aiChat_waitSlowHint: '匹配還在進行中，請再稍候片刻；也可以先在下方搜尋群組',
  aiChat_creatingSlowHint: '建群還在進行中，請再稍候片刻；建好後會直接帶你進入發布',
  aiChat_pickChannelEmptyHint: '沒找到相關的群組，建立一個新群組發布吧',
  aiChat_loadMore: '載入更多',
  sidebar_publish: '發布訊息',
  chat_selectLocationOnMap: '選擇位置',

  // App.vue 新增
  placeholder_email: '請輸入電子郵件',
  placeholder_mobile: '請輸入手機號碼',
  placeholder_password: '請輸入密碼',
  placeholder_name: '請輸入你的暱稱',
  random_nickname: '隨機',
  placeholder_verification_code: '請輸入驗證碼',
  sending: '發送中...',
  registering: '註冊中...',
  send_code: '發送驗證碼',
  retry_in_seconds: '{countdown}秒後重試',
  toast_enter_email: '請輸入電子郵件',
  toast_enter_mobile: '請輸入手機號碼',
  toast_invalid_email: '請輸入有效的電子郵件格式',
  toast_invalid_mobile: '請輸入有效的手機號碼',
  toast_send_code_failed: '驗證碼發送失敗',
  toast_code_sent: '驗證碼已發送至電子郵件',
  toast_code_sent_sms: '驗證碼已發送至手機',
  toast_send_code_error: '驗證碼發送失敗，請稍後重試',
  toast_fill_all_fields: '請填寫所有欄位',
  toast_login_failed: '登入失敗',
  toast_login_success: '登入成功',
  oauthOr: '或',
  toast_oauth_login_failed: 'Google 登入失敗',
  toast_oauth_login_error: 'Google 登入出錯，請重試',
  toast_login_error: '登入失敗，請稍後重試',
  toast_register_failed: '註冊失敗',
  toast_register_success: '註冊成功',
  toast_register_error: '註冊失敗，請稍後重試',

  // AdBanner.vue
  ad: '廣告',

  // ContactAdGate.vue 联系前广告闸门
  contactAd_gateTitle: '聯繫前的短暫等待',
  contactAd_gateSubtitle: '這幾秒廣告讓 OctoSay 能持續免費營運，謝謝支持！',
  contactAd_waitBtn: '{sec} 秒後可繼續',
  contactAd_continueBtn: '繼續聯繫',

  // ChannelDetail.vue 私聊按钮
  session_privateChat: '私訊',

  // AiMatch.vue
  ai_welcome_msg: '我是 AI，告訴我你想說什麼——找夥伴、找搭擋、技能交換、或任何事。',
  default_username: '使用者',

  // AvatarCropDialog.vue
  crop_hint: '捏合縮放，拖動調整',
  toast_crop_failed: '裁切圖片失敗',

  // ChatBox.vue
  loading_match_info: '正在載入配對資訊...',
  view_match_details: '查看配對詳情',
  step_clarify_needs: '簡單聊聊',
  step_ai_matching: '發布到群組',
  step_connect: 'AI 持續配對',
  make_private: '設為私密',
  setting: '設定中...',
  action_photo: '照片',
  channel_image_limit: '僅支援1張',
  action_file: '檔案',
  action_video: '影片',
  action_location: '位置',
  hint_get_app: '下載 App 保持聯絡',
  match_finding_title: '配對結果',
  match_finding_subtitle: 'AI 正在持續為你搖合適的人',
  match_time_hint: '此過程通常需要1-2分鐘',
  match_result_stats: '找到了 {matched} 個配對{interested}',
  match_tap_to_connect: '點擊開始私訊',
  match_channel_hint: '正在群組 #{channel} 中配對。優先同群組配對，但必要時也可能包含其他群組。',
  label_perfect_match: '最佳配對',
  label_worth_a_look: '值得一看',
  match_no_result_title: '正在為你尋找合適的對象',
  match_no_result_desc: '分享更多細節，幫助 OctoSay 配對到合適的對象。',
  go_back: '返回',
  no_public_requirements: '暫無公開內容',
  channelEmpty_title: '群組裡靜悄悄',
  channelEmpty_subtitle: '成為第一個分享想法的人吧',
  channelEmpty_hint: "寫下你的想法，AI 會幫你釐清並持續配對，讓訊息不沉底",
  channelEmpty_action: '說說你的想法',
  stay_connected: '保持聯絡',
  download_app_desc: '下載 App 即可聊天，並在有人聯絡你時立即收到通知！',
  app_store: 'App Store',
  google_play: 'Google Play',
  direct_apk: '直接下載 APK',
  match_history: '配對歷史',
  no_match_history: '暫無配對歷史',
  finding_matches: 'AI 正在持續為你搖人 - 發布訊息到群組後即可',
  discover_connect_hint: '配對成功即可開始聊天',
  match_initializing: '正在初始化...',
  placeholder_login_to_chat: '請登入後告訴我你想說什麼',
  toast_need_clear: '你的想法已明確！',
  toast_ai_responding: 'AI 正在回覆，請稍候...',
  toast_uploading_image: '正在上傳圖片，請稍候...',
  toast_uploading_file: '正在上傳檔案，請稍候...',
  toast_max_photos: '最多允許 {max} 張照片',
  toast_uploading: '正在上傳，請稍候...',
  toast_file_too_large: '{name} 超過5MB限制',
  toast_video_too_large: '{name} 超過20MB限制',
  toast_video_processing: '影片處理中，請稍候…',
  toast_upload_link_failed: '取得上傳連結失敗',
  analyzing_image: '正在分析圖片...',
  toast_location_confirmed: '位置已確認',
  toast_location_selected: '位置已選擇',
  toast_enter_search: '請輸入搜尋內容',
  toast_search_failed: '搜尋失敗',
  toast_no_locations: '未找到位置',
  toast_search_error: '搜尋失敗，請重試',
  toast_located_at: '定位到：{address}',
  toast_shared_finding: '已分享！正在尋找配對...',
  toast_update_failed: '更新失敗',
  toast_set_private: '已設為私密',
  toast_no_matches: '未找到配對',
  toast_matches_found: '找到了 {count} 個配對',
  toast_start_conversation_first: '請先開始對話',
  toast_load_history_failed: '載入配對歷史失敗',
  toast_ai_timeout: 'AI 回應逾時，請重試',
  toast_message_blocked: '訊息被封鎖',
  network_disconnected: '網路已斷線',
  toast_publish_success: '已發布到群組！',
  toast_publish_failed: '發布到群組失敗',

  // ChatMsgList.vue
  collapse_thinking: '收合思考過程',
  expand_thinking: '展開思考過程',
  thinking: '思考中',
  select_date: '選擇日期',
  selected_location: '已選位置',
  msg_blocked: '被封鎖',
  retry: '重試',
  msg_read: '已讀',
  msg_sent: '已送達',
  msg_unread: '未讀',
  label_start_datetime: '開始日期和時間：',
  label_end_datetime: '結束日期和時間：',
  toast_select_start_datetime: '請選擇開始日期和時間',
  toast_end_before_start: '結束時間不能早於開始時間',
  report_message: '檢舉訊息',
  block_user: '封鎖使用者',
  msg_revoke: '收回',
  msg_quote: '引用',
  msg_revoked_self: '你收回了一則訊息',
  msg_revoked_other: '對方收回了一則訊息',
  // 引用塊內使用中性文案：收回者是被引用訊息的發送者，與目前訊息方向無關
  msg_revoked_generic: '訊息已收回',
  // Platform removal (content moderation manual review), distinct from self-revoke
  msg_revoked_platform: '該訊息因違規已被平台收回',
  msg_blocked_label: '此訊息已被平台封鎖',
  toast_revoke_success: '已收回',
  toast_revoke_failed: '收回失敗',
  toast_load_data_failed: '載入資料失敗，請重新整理重試',
  toast_file_url_missing: '檔案連結不存在',
  toast_block_success: '使用者封鎖成功',
  toast_block_failed: '封鎖使用者失敗',

  // ChatSession.vue
  no_more_records: '沒有更多了',
  title_needs_clarified: '想法已明確',
  title_clarifying: '正在幫你釐清想法',
  title_public: '公開',
  title_private: '私密',
  badge_clarified: '已明確',
  badge_clarifying: '明確中',
  badge_only_me: '僅自己',
  badge_expired: '已過期',
  title_expired: '已過期',
  no_chat_history: '暫無聊天紀錄',

  // ContactMethods.vue
  block_status_banner: '你已封鎖此使用者',
  unblock_user: '解除封鎖',
  toast_block_missing_id: '無法封鎖：缺少使用者ID',
  dialog_block_confirm: '你確定要封鎖 {name} 嗎？你將不再收到對方的訊息。',
  toast_user_blocked: '已封鎖 {name}',
  toast_unblock_missing_id: '無法解除封鎖：缺少使用者ID',
  toast_user_unblocked: '{name} 已解除封鎖',

  // BlockedUsers.vue
  blocked_users: '封鎖的使用者',
  blocked_users_empty: '還沒有封鎖的使用者',
  blocked_users_empty_hint: '被你封鎖的使用者將無法再給你發送訊息',
  blocked_users_unblock: '解除封鎖',
  dialog_unblock_confirm: '解除後，對方將可以重新給你發送訊息。',
  toast_unblock_success: '已解除封鎖',
  toast_unblock_failed: '解除封鎖失敗，請重試',
  blocked_users_load_failed: '載入失敗，點擊重試',
  blocked_users_blocked_at: '封鎖於 {date}',
  blocked_users_unknown_user: '未知使用者',

  // Contacts.vue
  no_connections: '暫無私訊',
  chat_with: '與 {name} 聊天',
  toast_load_contacts_failed: '載入聯絡人失敗：{msg}',
  toast_load_contacts_error: '載入聯絡人失敗，請重新整理重試',
  time_just_now: '剛剛',
  time_minutes_ago: '{min}分鐘前',
  time_hours_ago: '{hour}小時前',
  time_days_ago: '{day}天前',

  // InteractionNotification.vue
  interaction_notification_title: '互動通知',
  interaction_notification_subtitle: '查看留言和按讚',
  interaction_notification_empty: '暫無互動通知',
  interaction_notification_comment: '留言了：{content}',
  interaction_notification_like: '讚了你的貼文',
  interaction_notification_reply: '回覆了：{content}',
  interaction_notification_bookmark: '收藏了你的貼文',
  toast_load_notifications_failed: '載入通知失敗：{msg}',
  toast_load_notifications_error: '載入通知失敗，請重新整理重試',
  mark_all_read: '全部標記為已讀',
  toast_mark_all_read_failed: '操作失敗，請重試',
  contacts_dnd: '訊息勿擾',
  dnd_enabled: '已開啟勿擾',
  dnd_disabled: '已關閉勿擾',
  dnd_action_enable: '開啟勿擾',
  dnd_action_disable: '關閉勿擾',

  // Discover.vue
  toast_load_sessions_failed: '載入會話失敗：{msg}',
  toast_load_sessions_error: '載入會話失敗',
  discover_noMessages: '暫無訊息',

  // EmojiInputArea.vue
  placeholder_default: '和 AI 補充更多細節',
  userChat_typeMessage: '輸入訊息...',
  select_emoji: '選擇表情',
  badge_new: '新',
  channel_search_placeholder: '請輸入頻道',
  channel_picker_empty: '請輸入頻道',

  // FrontPage.vue
  tab_chat_with_ai: '讓 OctoSay 懂你',
  history_chats: '歷史',
  tab_connections: '搖到的TA',
  tab_conversations: '訊息',
  tab_profile: '我的',
  new_session: '新增',
  history_tab_chats: '我的',
  history_tab_matches: '搖到的TA',
  channels_octosay: 'Octo 群組',
  tab_matches: '搖到的TA',
  tab_messages: '訊息',

  // Header.vue
  slogan: 'OctoSay - AI理解你，搖到對的TA',
  app_name: 'OctoSay',
  slogan_short: 'AI理解你，搖到對的TA',
  slogan_ai: 'AI 幫你配對到對的人',
  get_the_app: '下載 App',
  desc_iphone_ipad: 'iPhone / iPad',
  desc_android: 'Android',
  search_in_app_stores: '或在應用程式商店搜尋 OctoSay',

  // MapLocationPicker.vue
  placeholder_search_location: '搜尋位置...',
  coords_display: '位置：{lng},{lat}',
  toast_no_geolocation: '您的瀏覽器不支援地理定位',
  toast_location_permission_denied: '無法取得您的位置，請檢查定位權限',
  loading_address: '正在解析地址...',

  // MatchedSession.vue
  created_at: '建立於：{time}',
  ai_match_analysis: 'AI 配對分析',
  error_missing_session_params: '缺少必要的會話參數',
  match_private_hint: '該會話已設為私有，內容不可查看',

  // PersonalCenter.vue
  label_name: '暱稱：',
  placeholder_enter_name: '輸入你的暱稱',
  label_bio: '簡介：',
  placeholder_enter_bio: '寫點什麼介紹一下自己吧',
  placeholder_bio_empty: '寫點什麼介紹下自己吧',
  bio: '簡介',
  delete_account: '刪除帳號',
  delete_warning: '此操作無法復原。',
  delete_data_intro: '以下資料將被永久刪除：',
  delete_item_profile: '你的個人資料',
  delete_item_chat: '聊天紀錄和會話',
  delete_item_contact: '聯絡人資訊',
  delete_item_all: '所有相關資料',
  final_confirmation: '最終確認',
  delete_confirm_prompt: '請鍵入 "delete" 以確認：',
  placeholder_type_delete: '鍵入 delete',
  private_token: '私有權杖',
  token_desc: '產生用於 API 存取的權杖',
  toast_not_logged_in: '使用者未登入',
  toast_name_required: '暱稱不能為空',
  toast_save_success: '儲存成功',
  toast_save_failed: '儲存失敗',
  toast_image_too_large: '圖片超過5MB限制',
  toast_avatar_updated: '大頭貼已更新',
  toast_avatar_failed: '大頭貼更新失敗',
  toast_upload_failed: '上傳失敗',
  toast_token_generated: '權杖已產生',
  toast_token_failed: '產生權杖失敗',
  toast_copied: '已複製到剪貼簿',
  toast_copy_failed: '複製失敗',
  toast_account_deleted: '帳號刪除成功',
  toast_delete_account_failed: '刪除帳號失敗',
  toast_logout_success: '登出成功',
  toast_logout_failed: '登出失敗',
  profile_tab_messages: '訊息',
  profile_tab_comments: '留言',
  profile_tab_likes: '按讚',
  profile_tab_bookmarks: '收藏',
  profile_empty_messages: '還沒有發過訊息',
  profile_empty_comments: '還沒有留言',
  profile_empty_likes: '還沒有按讚',
  profile_empty_bookmarks: '還沒有收藏',
  profile_reply_to: '回覆{name}',
  profile_stats_posts: '訊息',
  profile_stats_comments: '留言',
  profile_stats_likes: '獲讚',
  profile_joined: '{date} 加入',

  // ReportDialog.vue
  report_message_title: '檢舉訊息',
  report_reason_prompt: '請選擇檢舉原因：',
  report_spam: '垃圾訊息',
  report_harassment: '騷擾或霸凌',
  report_inappropriate: '不當內容',
  report_other: '其他',
  placeholder_report_desc: '請描述問題（可選）',
  toast_select_reason: '請選擇原因',
  toast_report_success: '檢舉提交成功。感謝你的回饋。',
  toast_report_failed: '檢舉提交失敗',

  // common.js
  ellipsis: '..',

  // ChatBox.vue 訊息摘要前綴
  summary_image: '[圖片]',
  summary_images: '[圖片x{count}]',
  summary_file: '[檔案]',
  summary_files: '[檔案x{count}]',
  summary_video: '[影片]',
  summary_videos: '[影片x{count}]',
  summary_location: '[位置]',
  summary_locations: '[位置x{count}]',
  summary_emoji: '[表情]',
  summary_emojis: '[表情x{count}]',
  summary_voice: '[語音]',
  summary_voices: '[語音x{count}]',
  summary_mixed: '[混合內容]',
  summary_other: '[其他]',

  // 語音訊息
  voice: '語音',
  voice_recording: '錄音中...',
  toast_voice_too_short: '錄音時間太短',
  toast_voice_failed: '語音發送失敗',
  toast_mic_permission_denied: '無法存取麥克風，請在瀏覽器設定中開啟權限',
  toast_recording_not_supported: '目前瀏覽器不支援語音錄製',
  voice_load_failed: '語音載入失敗',

  // Expire At
  aiChat_expireLine: '有效期至 {date}，隨時告知 AI 更新',
  aiChat_expireExpired: '內容已過期，不再對外顯示，隨時告知 AI 更新過期時間',

  // MatchedSession.vue
  detail: '詳情',

  // Match notification hints
  match_new_result_hint: '之後可能會有新的配對結果，請安裝 App 以即時接收通知',

  // Match notification hints
  match_connection_notify_hint: '配對已建立並通知！快去打個招呼吧~',
  match_continuousMatching: 'AI 正在持續為你搖合適的人',
  match_continuousMatchingHint: '有新的結果我會第一時間通知你',
  match_continuousMatchingOthers: 'AI 正在持續為對方搖合適的人',
  match_continuousMatchingOthersHint: '有新的結果會更新顯示在這裡',
  match_noResultsTitleOthers: '正在為對方尋找合適的人',
  match_noResultsHintOthers: 'AI 正在持續為對方搖合適的人，一旦找到會顯示在這裡',
  match_newMatchFound: '發現 {n} 個新配對！',
  match_worth_exploring_hint: '由你決定是否主動聯絡。',

  // Matches filter tags
  filter_all: '全部',
  filter_best_connection: '最佳配對',
  filter_worth_a_look: '值得一看',

  // LandingPage.vue (Global portal)
  landing_brand_slogan: 'OctoSay - AI理解你，搖到對的TA',
  landing_hero_title: '在群組裡寫下想說的話，AI 先確認，你確認後連摘要一起發出去',
  landing_hero_subtitle: '在 Octo 群組 裡輸入你想說的話，AI 會先和你聊天確認細節。你確認發布後，你的原訊息和配對摘要會一起發到群組裡，AI 再持續為你配對到合適的TA',
  landing_download_on: '下載',
  landing_get_it_on: '取得',
  landing_direct_download: '直接下載',
  landing_how_title: '使用三步',
  landing_step1_title: '在群組裡寫下訊息',
  landing_step1_desc: '在 Octo 群組 裡輸入你想表達的內容。訊息不會直接發出去，AI 會先和你聊天確認細節，讓每則訊息都清晰有用、值得配對，而不是淹沒在雜亂聊天裡。',
  landing_step2_title: '確認後發布並配對',
  landing_step2_desc: '你確認發布後，你的原訊息和 AI 提煉的配對摘要會一起發到群組裡。AI 接著持續為你配對最合適的對象，避免訊息發完就石沉大海沒人看到。',
  landing_step3_title: '配對後自然聊',
  landing_step3_desc: '配對成功後，雙方都能看到彼此和 AI 的聊天紀錄以及配對摘要。有共同語境，破冰自然不尷尬，聊起來更輕鬆。',
  // Comparison Section
  landing_comparison_title: '為什麼選擇 OctoSay？',
  landing_comparison_subtitle: '群組形式，但 AI 幫你確認細節、主動配對。',
  landing_comparison_other: 'Discord',
  landing_comparison_octo: 'OctoSay',
  landing_cmp1_label: '內容品質',
  landing_cmp1_other: '廣告、灌水、離題訊息洗版',
  landing_cmp1_octo: '僅顯示 AI 篩選的需求卡片',
  landing_cmp2_label: '找人',
  landing_cmp2_other: '發了訊息然後祈禱有人看到',
  landing_cmp2_octo: 'AI 主動為你配對合適的人',
  landing_cmp3_label: '噪音程度',
  landing_cmp3_other: '需要翻閱上百條訊息',
  landing_cmp3_octo: '零噪音，每則訊息都有意義',
  landing_cmp4_label: '上手難度',
  landing_cmp4_other: '找伺服器、翻頻道、自己摸索',
  landing_cmp4_octo: '在群組裡寫訊息，AI 來確認配對',
  landing_cmp_other_wechat: '微信',
  landing_cmp_other_xhs: '小紅書',
  landing_cmp_other_facebook: 'Facebook',
  landing_cmp_other_reddit: 'Reddit',
  landing_cmp1_wechat: '群組訊息洗版、廣告灌水',
  landing_cmp1_xhs: '行銷筆記多、真假難辨',
  landing_cmp1_facebook: '廣告和標題黨洗版',
  landing_cmp1_reddit: '灌水、離題貼到處都是',
  landing_cmp2_wechat: '只能靠通訊錄和拉群組',
  landing_cmp2_xhs: '得自己搜尋、慢慢翻找',
  landing_cmp2_facebook: '局限在已有好友和社團裡',
  landing_cmp2_reddit: '自己翻版塊、發文等回覆',
  landing_cmp3_wechat: '群組聊天幾百條訊息爬樓',
  landing_cmp3_xhs: '資訊流全是推薦和廣告',
  landing_cmp3_facebook: '推薦文和廣告看不完',
  landing_cmp3_reddit: '留言區要翻上百條',
  landing_cmp5_label: '找人方式',
  landing_cmp5_wechat: '自己一個個問、碰運氣',
  landing_cmp5_xhs: '發筆記等留言、還得自己篩',
  landing_cmp5_facebook: '得自己在群組裡到處問',
  landing_cmp5_reddit: '自己發文、等回覆、再篩選',
  landing_cmp5_octo: 'AI 幫你持續自動找人',
  landing_features_title: '核心特性',
  landing_feature1_title: '發布前先確認',
  landing_feature1_desc: '不需要填表。在群組裡寫下你想說的話，AI 會在發布前先和你聊天、追問細節，真正理解你的需求',
  landing_feature2_title: 'Octo 群組 配對',
  landing_feature2_desc: '你的訊息和配對摘要一起發到 Octo 群組，OctoSay 持續從群友中為你配對到答案或共鳴，告訴你為什麼適合你',
  landing_feature3_title: '主動配對',
  landing_feature3_desc: '你確認發布後，AI 會持續在群組裡為你尋找契合的人，不用你搜尋或翻找',
  landing_feature4_title: 'Octo 群組 社群',
  landing_feature4_desc: '加入感興趣的 Octo 群組，獲取答案、找到夥伴，讓連結更自然更有溫度',
  landing_feature5_title: '隱私保護',
  landing_feature5_desc: '發送後可選擇設為私有，僅自己可見，完全掌控你的資訊',
  landing_feature6_title: '有效溝通',
  landing_feature6_desc: '沒有噪音，沒有雜亂的干擾訊息，每則訊息都有意義',
  landing_usecases_title: '適用於任何場景',
  landing_usecases_subtitle: '無論你想做什麼、需要什麼，AI 都能理解並幫你搞定',
  landing_usecase_game: '遊戲夥伴',
  landing_usecase_language: '語言交換',
  landing_usecase_skill: '技能交換',
  landing_usecase_roommate: '找室友',
  landing_usecase_travel: '旅遊夥伴',
  landing_usecase_sports: '運動夥伴',
  landing_usecase_study: '學習搭擋',
  landing_usecase_anything: '...或分享任何事',
  landing_cta_title: '準備好了嗎？',
  landing_cta_desc: '加入 Octo 群組，寫下你想說的話，讓 AI 先確認、你確認後再發布，並持續幫你配對到對的人。現在就開始。',
  landing_use_now: '立即使用',
  landing_groups: 'Octo 群組',

  // OnboardingPage.vue
  onboarding_skip: '略過',
  onboarding_next: '下一步',
  onboarding_getStarted: '開始使用',
  onboarding_step1Title: "在群組說出你的需求",
  onboarding_step1Desc: "想找什麼、想做什麼，直接說出來就行。AI 會先和你聊幾句澄清細節，幫你整理成清晰有效的一句話，讓對的人一眼看懂。",
  onboarding_step2Title: '確認後發布並配對',
  onboarding_step2Desc: "訊息發到群組後，AI 會持續為你配對最合適的對象，避免訊息發完就石沉大海沒人看到。",
  onboarding_step3Title: '配對後自然聊',
  onboarding_step3Desc: "雙方都能看到彼此和 AI 聊過的內容，知道對方想要什麼。有共同語境，破冰自然不尷尬，聊起來更輕鬆。",

  // ChannelMembers.vue
  channel_members_empty: '暫無成員',
  channel_members_title: '群組成員',
  channel_role_owner: '群組擁有者',
  channel_role_admin: '管理員',
  channel_role_member: '成員',

  // Settings.vue
  settings_language: '語言',
  settings_language_followSystem: '跟隨系統',

  // ChatBox.vue
  match_interested_suffix: '，{count} 個值得一看',

  // ChatBox.vue - AI匹配進度階段
  match_stage_fetch_chat: '取得對話',
  match_stage_query_expansion: '擴展查詢',
  match_stage_semantic_search: '語義搜尋',
  match_stage_deep_search: '深度分析',
  match_stage_rerank: '智能匹配',
  match_stage_refining: '優化結果',
  match_stage_fetch_details: '取得詳情',

  // ChannelDetail.vue - 圖片上傳
  channel_select_image: '請選擇圖片檔案',
  channel_image_upload_failed: '圖片上傳失敗，請重試',
  chatInput_channelSearchHint: "搜尋群組名稱",
}



// WEBPACK FOOTER //
// ./src/i18n/zhHant.js